import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../components/breadcrumbs";
import Banner from "../../components/img_bannerblogs";
import RCMcy from "../../images/BlogCardImgs/acersmedicalbillgtechniques1.webp";
import BlogImg7 from "../../images/BlogCardImgs/obtainingmedicalbillingservicesfromthebestmedical1.webp";
import BlogImg2 from "../../images/BlogCardImgs/choosingtooutsourceyourmedicalbillingisasmartdecision1.webp";
import BlogImg15 from "../../images/BlogCardImgs/managementofhealthcarerevenuecycle1.webp";
import BlogImg16 from "../../images/BlogCardImgs/detailsaboutpatientsareprotectedbyacer1.webp";
import Blogcontent from "../../img/Blogcontent1/blog content images  12.jpg";
import Blogcontent2 from "../../img/Blogcontent1/MedicalBillingCycle.jpg";
import "../../css/testcard.css";
import { Helmet } from "react-helmet";
import Tablecontent from "../Blogs/Blogstablecontent";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";

import DownContact from "../../components/downcontact";

const About = () => {
  useEffect(() => {
    // change title of page
    document.title = "AcerHealth's Medical Billing Techniques";
  }, []);

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({
    title: "AcerHealth's Medical Billing Techniques",
    subtitle: "",
    img: `url(${RCMcy})`,
  });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({
    title: "WE HELP DOCTORS COLLECT MORE MONEY FASTER AND EASIER",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  });

  return (
    <>
      <Helmet>
        <style>{`body { overflow-x: hidden; }`}</style>
        <title>Medical Billing Techniques | Acer Health Blog</title>
        <link rel="canonical" href=" https://acerhealth.com/blog/medical-billing-techniques" />



        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://acerhealth.com/medical-billing-techniques"
            },
            "headline": "AcerHealth's Medical Billing Techniques: A Comprehensive Guide to Optimize Revenue and Accuracy",
            "description": "Discover how AcerHealth uses smart tools, automation, and structured medical billing services to help healthcare providers increase revenue, ensure accuracy, and enhance compliance.",
            "image": "https://acerhealth.com/images/medical-billing-guide.jpg",
            "author": {
              "@type": "Organization",
              "name": "AcerHealth",
              "url": "https://acerhealth.com"
            },
            "publisher": {
              "@type": "Organization",
              "name": "AcerHealth",
              "logo": "%PUBLIC_URL%/favicon.png"
            },
            "datePublished": "2025-05-30",
            "dateModified": "2025-05-30",
            "keywords": [
              "Medical Billing",
              "Revenue Cycle Management",
              "Denial Management",
              "HIPAA Compliance",
              "Medical Billing Automation",
              "Healthcare Technology",
              "Claim Management",
              "Patient Billing"
            ]
          })}
        </script>

        <meta name="description" content="Discover effective medical billing techniques from Acer Health. Learn best practices to optimize your billing process and improve revenue cycle management"
        />
      </Helmet>

      <Banner BannerTitle={BannerTitle} />
      <div className="container mb-4 mt-4 d-flex">
        <div style={{ maxWidth: "fit-content", width: "fit-content" }}>
          <BreadCrumbs
            paths={[
              { name: "Home", link: "/" },
              { name: "Blogs", link: "/medical-billing-blogs" },
              { name: "AcerHealth's Medical Billing Techniques" },
            ]}
          />
        </div>
      </div>
      <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
        <MDBCol md="3" className="toc-sticky">
          <Tablecontent />
        </MDBCol>
        <MDBCol md="7" className="content" style={{ paddingRight: "50px" }}>
          <h1 style={{ textAlign: "center", fontSize: "30px", fontFamily: "Alegreya Sans", }} className="mb-4" >
            <b>AcerHealth's Medical Billing Techniques: A Comprehensive Guide to Optimize Revenue and Accuracy</b>
          </h1>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Efficient <b>medical billing techniques</b> are crucial for healthcare providers aiming to secure timely and accurate reimbursements.
            Mistakes and delays can result in significant revenue loss. As healthcare technology continues to evolve, billing systems grow more
            complex—but also more manageable. At AcerHealth, we leverage smart tools and structured <a href='https://acerhealth.com/services/medical-billing-services' 
            style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">medical billing services </a> that help providers get paid faster
            and more reliably. This guide outlines how our approach transforms billing into a streamlined, revenue-generating system with <b>coding accuracy </b>and
            compliance at its core.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Whether you're managing a large hospital or operating a small practice,
            our <a href='https://acerhealth.com/services/revenue-cycle-management' style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">
              revenue cycle management </a> strategies are tailored to improve cash flow,
            accuracy, and patient satisfaction. Explore our full range of <b>medical billing services </b>to see how we can support your practice.
          </p>

          <div className="mb-3">
            <img
              src={Blogcontent}
              alt="AcreHealth medical Billing techniques"
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>

          <h2 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            <b>Understanding Our Medical Billing Philosophy</b>
          </h2>

          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            At AcerHealth, our work is guided by principles that prioritize accuracy, <b>HIPAA compliance</b>, and <a href='https://acerhealth.com/technologies/patient-statements-payment-portal' 
            style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">patient billing transparency</a>.
            We make sure every claim is filed correctly the first time, minimizing errors and costly denials. Protecting sensitive patient information is non-negotiable,
            which is why HIPAA-aligned systems are baked into every part of our billing process.
          </p>

          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            We also believe billing should be easy to understand for patients. Transparent invoices build trust, ease confusion,
            and encourage quicker payments. When patients feel informed, billing becomes less stressful—for them and your staff.
          </p>



          <h2 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            <b>Advanced Technology in Our Medical Billing Process </b>
          </h2>


          <div className="mb-3">
            <img
              src={Blogcontent2}
              alt="AcerHealth medical billing cycle infographic showing steps from patient encounter to performance monitoring."
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>


          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <h3 style={{ fontSize: "22px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Integration of Electronic Health Records (EHR)
              </h3>
              <p
                style={{
                  fontSize: "18px",
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                }}
              >
                We integrate <a href='https://acerhealth.com/blog/unveiling_the_core_concepts_of_electronic_health_records_EHRs'
                  style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">Electronic Health Records (EHR) </a> to reduce
                manual data entry and human error. Real-time updates improve <b>coding accuracy</b>, making the billing process more efficient and synchronized with clinical documentation.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "22px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Use of Artificial Intelligence and Medical Billing Automation
              </h3>
              <p
                style={{
                  fontSize: "18px",
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                }}
              >
                With intelligent systems and <b>medical billing automation</b>, we streamline claim submission and follow-up. Our AI tools proactively flag
                potential issues—like missing documentation or incorrect codes—enhancing both <b>accuracy</b> and speed.
                <a href='https://acerhealth.com/blog/reduce-claim-denials' style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer"> These tools play a crucial role in our denial management
                </a> process by identifying and resolving errors before claims are rejected.
              </p>
            </li>
          </ul>



          <h2 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            <b>Data Security and HIPAA Compliance</b>
          </h2>

          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            In an age where data security is critical, AcerHealth adheres to stringent <a href='https://www.hhs.gov/hipaa/for-professionals/index.html'
              style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">HIPAA compliance </a> protocols.
            All patient data is encrypted, securely stored, and regularly audited. These efforts not only protect your patients, but also build confidence in your practice and mitigate legal risk.
          </p>


          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans", fontWeight: "700", marginBottom: "15px" }}>
            Claim Management and Submission Strategies
          </h2>

          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Accurate Coding and Documentation
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                Our certified coders ensure every procedure and diagnosis is accurately captured.
                <a href='https://www.cms.gov/cms-guide-medical-technology-companies-and-other-interested-parties/coding/overview-coding-classification-systems' style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">
                  Coding accuracy</a> directly impacts your reimbursement rate and reduces the likelihood of claims being returned or denied.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Real-Time Claim Scrubbing
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                We use <a href='https://acerhealth.com/technologies/patient-balance-estimator' style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">automated tools </a>
                to review claims before submission, identifying issues like mismatched codes or incomplete data. This minimizes rework and improves first-pass acceptance rates.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Efficient Payer Communication
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500" }}>
                We maintain direct lines of communication with insurers via secure portals and dedicated contacts. These connections help us resolve queries faster,
                shortening the payment cycle and supporting better <b>revenue cycle management</b>.
              </p>
            </li>
          </ul>



          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans", fontWeight: "700", marginBottom: "15px" }}>
            Denial Management and Appeals Process
          </h2>

          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Root Cause Analysis of Denia
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                Every denied claim is an opportunity to improve. We analyze the <b>root causes of denials,</b> such as documentation gaps or coding inconsistencies,
                and use this data to refine our processes and avoid repeat errors.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Effective Reconsideration and Appeals
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                Our specialists draft compelling appeal letters supported by strong evidence and proper documentation. We track appeals in real time
                to ensure that no claim goes unresolved.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Continuous Process Improvement
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500" }}>
                Our <b>denial management</b> framework is cyclical and self-improving. We use denial trends to inform staff training and update workflows,
                boosting success rates over time. Learn more on our <b>Revenue Cycle Management</b> page.
              </p>
            </li>
          </ul>

          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans", fontWeight: "700", marginBottom: "15px" }}>
            Optimizing Revenue Cycle Management
          </h2>

          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Patient Billing and Collections
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                We emphasize <b>patient billing transparency</b> by sending easy-to-read invoices and offering user-friendly online payment options. This increases the likelihood of on-time payments and reduces collection challenges.
              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Training and Staff Development
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", marginBottom: "15px" }}>
                Our staff undergoes ongoing training to stay updated on payer guidelines and new <b>medical billing techniques</b>. A well-trained team contributes to fewer mistakes, smoother workflows, and better financial outcomes.              </p>
            </li>

            <li>
              <h3 style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "600", marginBottom: "5px" }}>
                Performance Metrics and Analytics
              </h3>
              <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500" }}>
                We track critical metrics like denial rates, collection ratios, and days in A/R using intuitive dashboards. These insights empower us to make data-driven decisions that fine-tune your <b>medical billing </b>process.              </p>
            </li>
          </ul>


          <h2 style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}>
            Conclusion{" "}
          </h2>
          <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
            At <b>AcerHealth</b>, we combine advanced <b>medical billing automation, real-time analytics,</b> and <b>smart denial management</b> to help healthcare providers
            streamline operations, improve coding accuracy, and ensure full <b>HIPAA compliance</b>. Our proven medical billing techniques are designed to reduce errors,
            accelerate reimbursements, and optimize revenue across the entire <b>revenue cycle management</b> process. By integrating transparent patient billing and
            proactive claims management, we enhance both financial performance and the patient experience. Whether you're a small practice or a large facility,
            our expert team and technology help you get paid faster—with fewer denials and administrative burdens
          </p>
          <p style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
            Let’s make your billing process better. <a href='https://acerhealth.com/contact-us' style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer"> Contact us </a>
            today to learn how AcerHealth’s expert team and smart technology can help you get paid faster—with fewer
            headaches.
          </p>
          <br></br>
          <br></br>
          {/* <a href="/" className="text-reset" style={{ color: "red" }}>
            <button style={{ background: "#3B0075", color: "white" }}>
              Learn more
            </button>
          </a> */}
          <hr className="style-eight" />

         
        </MDBCol>
        <MDBCol md="2" className="content" style={{ padding: "0px" }}>
          <MDBRow className="row-cols-1 row-cols-md-4 g-4">
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg7}
                    alt="Obtain Billing Services from the Best Medical Billing
                  Company"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="obtain_billing_services_from_the_best_medical_billing_company">
                        Obtain Billing Services from the Best Medical Billing
                        Company
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg2}
                    alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                        Choosing to Outsource Your Medical Billing is a Smart
                        Decision?
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg15}
                    alt="Management of the Healthcare Revenue Cycle"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="management_of_the_healthcare_revenue_cycle">
                        Management of the Healthcare Revenue Cycle
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg16}
                    alt="Details about Patients is Protected by AcerHealth"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="details_about_patients_is_protected_by_acerhealth">
                        Details about Patients is Protected by AcerHealth
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBCol>



   <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
 <MDBRow className="row-cols-1 row-cols-md-4 g-4 mb-2">
            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg7}
                  alt="Obtain Billing Services from the Best Medical Billing Company"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="obtain_billing_services_from_the_best_medical_billing_company">
                      Obtain Billing Services from the Best Medical Billing
                      Company
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg2}
                  alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                      Choosing to Outsource Your Medical Billing is a Smart
                      Decision?
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg15}
                  alt="Management of the Healthcare Revenue Cycle"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="management_of_the_healthcare_revenue_cycle">
                      Management of the Healthcare Revenue Cycle
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg16}
                  alt="Details about Patients is Protected by AcerHealth"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="details_about_patients_is_protected_by_acerhealth">
                      Details about Patients is Protected by AcerHealth
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
   </div>

  
      </div>
      {/* <DownContact DownContactTitle={DownContactTitle} /> */}
    </>
  );
};

export default About;
